import React, {useState} from 'react';
import AssetMemo from "../../../asset/mng/info/subPages/list/AssetMemo";
import Search from "../../../../components/search/Search";
import SearchSection from "../../../../components/search/SearchSection";
import Selector from "../../../../components/selector/Selector";
import {searchListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import {CacheType, CodeSpecNum} from "../../../../constant/CodeSpecNum";
import DrawerSelector from "../../../../components/drawer/drawer/DrawerSelector";
import UtilsBox from "../../../../components/Utils/UtilsBox";
import SimmsTable from "../../../../components/table/movable/SimmsTable";
import CommonPagination from "../../../../components/table/movable/CommonPagination";
import {useCacheRefresh} from "../../../../hooks/useCacheRefresh";
import {CLAIM_LIST_HEADER} from "../../../../components/table/header/Headers";
import {deleteAssets} from "../../../../api/asset/AssetService";
import {handleActiveError} from "../../../../components/sonner/ToastBasic";
import {deleteClaim} from "../../../../api/claim/ClaimService";

function ClaimListWeb({data, date, pageInfo, dataHook, getQr, checked, }) {

    const {handleSearch, handlePageSizeChange,searchConditions, saveConditions, refresh, handleSortChange, handlePageChange} = dataHook;

    const deleteHandler =()=>{
        deleteClaim(checked.checked).then(r=>{
            if(r.status==200){
                alert("삭제되었습니다.")
                refreshCache(CacheType.asset);
                refresh()
            }else if(r.status==201){
                handleActiveError({message: r.data.title, description: r.data.reason});
            }
        })
    }
    const refreshCache = useCacheRefresh();
    ///** 심스테이블추가
    const [header, setHeader] = useState({order:CLAIM_LIST_HEADER, exclude:[]});
    const [exclude, setExclude] = useState([]);
    const [pin, setPin] = useState();
    const searchDate = {startDate: saveConditions.startDate?? date.startDate ,endDate: saveConditions.endDate?? date.endDate }
    console.log(data);
    return (
        <div className="container-height">
            <Search entity={'claim'} handleSearch={handleSearch} refresh={refresh} searchConditions={saveConditions} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} searchBar={{ placeHolder : '제목, 요청번호'}} reset size detail date={searchDate} >
                <SearchSection title={'기본정보'}>
                    <Selector showLabel onChange={(value) => searchListener(handleSearch, 'code', saveConditions, value) }
                                 data={saveConditions.project}
                                 parentKey={CodeSpecNum.ClaimCode} recursive
                                 entity={"code"} title={"요청코드"}/>
                    <Selector showLabel onChange={(value) => searchListener(handleSearch, 'requester', saveConditions, value) }
                                 data={saveConditions.group}
                                 parentKey={CodeSpecNum.AssetGroupCode} recursive
                                 entity={"requester"} title={"요청자"}/>
                    <Selector showLabel onChange={(value) => searchListener(handleSearch, 'createdBy', saveConditions, value) }
                                 data={saveConditions.task}
                                 parentKey={CodeSpecNum.TaskGroupCode} recursive
                                 entity={"createdBy"} title={"등록자"}/>
                </SearchSection>
            </Search>


            <UtilsBox
                del={deleteHandler}
                qr={()=>getQr(checked)}
                // printer
                assetCheck
                excel={{key:'Claim', save:1,update:1, search:saveConditions}}
            />

            <SimmsTable

                //**심스테이블
                entity={"claim"}
                pin={pin}
                excludeArray={{target:exclude, fnc:setExclude}}
                header={header}
                //**

                handleSortChange={handleSortChange}
                checked={checked}
                data={data}
                page={pageInfo}
                url={'/standard/prevent/claim'}
            />

            <CommonPagination  page={pageInfo} onPageChange={handlePageChange}/>
        </div>
    );
}

export default ClaimListWeb;


